<template>

  <el-main>
    <el-main class="home">
      <MainBanner />
      <AIPlatform />
      <PartnerNew />
    </el-main>

  </el-main>
</template>

<script>
import MainBanner from "./MainBanner";
import AIPlatform from "./AiPlatform";
import PartnerNew from "./PartnerNew";

export default {
  name: "Main",
  components: {
    MainBanner,
    AIPlatform,
    PartnerNew
    },
  data() {
    return {
      dataimgs: [
        {
          id: 0,
          src1: require("@/assets/images/newbanner.png"),
          src2: require("@/assets/images/newbanner-2x.png"),
          url: "https://console.mopaas.com/web/spaces.jsp",
          title: "机器学习的算力优化和模型",
          content: [],
          btn: "联系我们",
          btnVisible: true
        },
        {
          id: 1,
          src1: require("@/assets/images/term-begins-banner.png"),
          src2: require("@/assets/images/banner-m.png"),
          url: "/term-begins-activity",
          title: "加速数字化转型的企业级云平台服务",
          content: ["MoPaaS与您一起创变未来"],
          btn: "立即体验"
        }
      ]
    };
  }
};
</script>

<style>
  .home .home-container:nth-of-type(odd) {
    background: #f1f7ff;
  }

  .home .home-container:nth-of-type(even) {
    background: #e7f1ff;
  }

  .home .home-title {
    padding: 63px 51px;
    font-size: 20px;
    line-height: 1;
    letter-spacing: 1em;
    color: #333;
  }

  .home .home-goAI {
    padding: 83px 0 69px;
    text-align: center;
    background: url("../assets/images/rengongbg.png");
  }

  .home-goAI__text {
    font-size: 20px;
    color: #fff;
    vertical-align: middle;
  }

  .home-goAI__btn {
    display: inline-block;
    padding: 15px 44px;
    border-radius: 2px;
    margin-left: 54px;
    font-size: 18px;
    color: rgba(36, 53, 73, 1);
    vertical-align: middle;
    background: rgba(0, 235, 246, 1);
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/Main.vue